import { TsDOM as q } from '@/scripts/core/TsDOM'
import { LongevityResultsBuyBox } from '@/scripts/sections/longevity-results-buy-box'
q.safeDefineElement(LongevityResultsBuyBox)
